import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Close from 'material-ui-icons/Close';
import IconButton from 'material-ui/IconButton';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

const styles = () => ({
  root: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    zIndex: 10,
  },

  iconButton: {
    position: 'absolute',
    right: 17,
    top: 15,
    color: 'white',
    width: 'unset',
    height: 'unset',
  },

  banner: {
    cursor: 'pointer',
    display: 'block',
    width: '300px',
  }
});

class Banner extends React.Component {
  handleClose = () => {
    const intervalYear = 2;
    this.props.cookies.set('showBanner', 0, { path: '/', expires: new Date(new Date().setFullYear(new Date().getFullYear() + intervalYear)) });
    this.props.toggleDialog();
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <IconButton onClick={this.handleClose} className={classes.iconButton}>
          <Close color="inherit" width='15' height='15' />
        </IconButton>

        <img
          src={require('../../../assets/images/banner-3@2x@2x.png')}
          alt="banner"
          className={classes.banner}
          onClick={() => window.open(process.env.REACT_APP_SMART_LETTER_TEMPLATE_URL, '_blank')} />
      </div>
    );
  }
}

Banner.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
  toggleDialog: PropTypes.func.isRequired,
  cookies: instanceOf(Cookies).isRequired,
};

Banner.defaultProps = {
}


export default withCookies(withStyles(styles)(Banner));



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/Banner.jsx